module.exports = __webpack_public_path__ + "static/img/161.1c423895.png";